import {TypeOf} from 'io-ts';
import {BaseCurrencyCode} from './BaseCurrencyCode';

export type CryptoCurrencyCode = TypeOf<typeof CryptoCurrencyCode>;
export const CryptoCurrencyCode = BaseCurrencyCode;
